import { Navigate } from 'react-router-dom';

import { useGetAdminToken, useIsAdminAuth } from '@admin/hooks';

export const AdminProtectedRoute = ({ children }) => {
  useGetAdminToken();
  const isAuth = useIsAdminAuth();

  if (!isAuth) {
    return <Navigate to="auth" state={{ from: location.pathname + location.search }} />;
  }
  return children;
};
